import { lazy, Suspense } from 'react';
import { Loader } from '@mantine/core';

// Lazy load heavy components
const ProductsTab = lazy(() =>
  import('./ProductsTab').then(module => ({ default: module.ProductsTab }))
);
const CoursesTab = lazy(() =>
  import('./CoursesTab').then(module => ({ default: module.CoursesTab }))
);
const CourseEditModal = lazy(() =>
  import('./CourseEditModal').then(module => ({
    default: module.CourseEditModal,
  }))
);
const DevicesTab = lazy(() =>
  import('./DevicesTab').then(module => ({ default: module.DevicesTab }))
);

// Loading fallback component
const LoadingFallback = () => (
  <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
    <Loader size='sm' />
  </div>
);

// Wrapper components with Suspense
export const LazyProductsTab = (props: any) => (
  <Suspense fallback={<LoadingFallback />}>
    <ProductsTab {...props} />
  </Suspense>
);

export const LazyCoursesTab = (props: any) => (
  <Suspense fallback={<LoadingFallback />}>
    <CoursesTab {...props} />
  </Suspense>
);

export const LazyCourseEditModal = (props: any) => (
  <Suspense fallback={<LoadingFallback />}>
    <CourseEditModal {...props} />
  </Suspense>
);

export const LazyDevicesTab = (props: any) => (
  <Suspense fallback={<LoadingFallback />}>
    <DevicesTab {...props} />
  </Suspense>
);
